import React from "react";
import ReactDOM from "react-dom";
import refresh from "../../assets/images/refresh.png"

const ReloadModal = ({ isShowing, hide }) =>
  isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="custom-modal-overlay" />
          <div
            className="custom-modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="custom-modal">
              <div className="custom-model-content">
                {/* <h1>Tabs Demo</h1> */}
                <div style={{width:"100%", textAlign:"center"}}>Sorry this site was built with low cost server</div>
                <div style={{width:"100%", textAlign:"center"}}>Please be patient or try later</div>
                <div style={{width:"100%", textAlign:"center"}}>
                <button style={{border:"none", backgroundColor:"transparent"}} onClick={()=>window.location.reload()}>
                    <img style={{width:"40px", height:"40px", backgroundColor:"transparent"}} src={refresh}/>
                </button></div>
              </div>
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
    : null;

export default ReloadModal;
